import { createModel } from '@/store/tools';

const model = {
    namespace: 'service',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getServiceList': T('getServiceList'),
            'getServiceInfo': T('getServiceInfo'),
            'getStatusEnum': T('getStatusEnum'),
        },
        actions: {
            'getServiceList': A('getServiceList'),
            'getServiceInfo': A('getServiceInfo'),
            'getStatusEnum': A('getStatusEnum'),
        },
        sagas: {
            'getServiceList': S('getServiceList', '/?cmd=com.xqxc.api.pig.mis.biz.user.goods.ExtraServiceMisService.findExtraServicePage'),
            'getServiceInfo': S('getServiceInfo', '/?cmd=com.xqxc.api.pig.mis.biz.user.goods.ExtraServiceMisService.findExtraServiceInfo'),
            'getStatusEnum': S('getStatusEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
        },
        reducers: {
            'serviceList': R('getServiceList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'serviceInfo': R('getServiceInfo', { mainImgUrlList: [] }),
            'statusEnum': R('getStatusEnum', []),
        }
    })
};
export default createModel(model);